import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useVendorsQuery } from '../../../api/gql';
import { notify } from '../../../utils/notification';
import { VendorsTable } from './modules/VendorsTable';

export const VendorsOverview = () => {
  const { t } = useTranslation();
  const { data, isLoading, error } = useVendorsQuery();

  useEffect(() => {
    if (error) {
      console.error(error);
      notify.negative({ message: t('query.error.default') });
    }
  }, [error, t]);

  return (
    <Box>
      <VendorsTable loading={isLoading} vendors={data?.vendors} />
      <Outlet />
    </Box>
  );
};
